import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(process.env.REACT_APP_SUPABASE_URL ?? "", process.env.REACT_APP_SUPABASE_KEY ?? "");

export const signIn = async (email: string, password: string) => {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (data.user) {
    return data.user?.id;
  } else {
    throw error?.message;
  }
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  console.error(error);
};
